<!--
首页
-->
<template>
  <div class="container">
    <a-spin tip="Loading..." :spinning="loading">
      <div class="my-primary-margin">
        <a-row :gutter="10">
          <a-col :span="12" class="m_top">
            <panel ref="panel" />
          </a-col>
          <a-col :span="12" class="m_top">
            <panel-large ref="panelLarge" />
          </a-col>
          <!-- 阳性检出率统计 -->
          <a-col :span="12" class="m_top" v-if="settingInfo.showPositive">
            <positive-detection-rate :chart-data="positiveData" height="280px" />
          </a-col>
          <!-- 分娩孕周分布比例 -->
          <a-col :span="12" class="m_top" v-if="settingInfo.showGestationalWeek">
            <gestational-week-distribution :chart-data="weekData" height="280px" />
          </a-col>
          <!-- 孕妇年龄分布占比 -->
          <a-col :span="12" class="m_top" v-if="settingInfo.showAge">
            <pregnant-women-age-distribution :chart-data="ageData" height="280px" />
          </a-col>
          <!-- 子痫前期患者各类风险因素占比统计 -->
          <a-col :span="12" class="m_top" v-if="settingInfo.showPreeclampsia">
            <eclampsia-risk-rate :chart-data="eclData" height="280px" />
          </a-col>
          <!-- 小于胎龄儿患者各类风险因素占比统计 -->
          <a-col :span="12" class="m_top" v-if="settingInfo.showSga">
            <sga-risk-rate :chart-data="eclData" height="280px" />
          </a-col>
          <!-- 唐氏综合征患者各类风险因素占比统计 -->
          <a-col :span="12" class="m_top" v-if="settingInfo.showDowns">
            <downs-risk-rate :chart-data="eclData" height="280px" />
          </a-col>
          <!-- 胎儿生长受限患者各类风险因素占比统计 -->
          <a-col :span="12" class="m_top" v-if="settingInfo.showFgr">
            <fgr-risk-rate :chart-data="eclData" height="280px" />
          </a-col>
          <!-- 静脉血栓患者各类风险因素占比统计 -->
          <!-- <a-col :span="12" class="m_top" v-if="settingInfo.showVte">
            <dvt-risk-rate :chart-data="eclData" height="280px" />
          </a-col> -->
          <a-col :span="24" v-if="settingInfo.showPlgf">
            <mark-point idName="prePlgf" :chartName="$t('risk.preeclampsia')" markerName="PLGF" unit="pg/mL" :allMarkerType="4" :itemType="0" height="280px" />
          </a-col>
          <a-col :span="24" v-if="settingInfo.showPappa">
            <mark-point idName="prePappa" :chartName="$t('risk.preeclampsia')" markerName="PAPP-A" unit="uIU/mL" :allMarkerType="5" :itemType="0" height="280px" />
          </a-col>
          <a-col :span="24" v-if="settingInfo.showSflt">
            <mark-point idName="preSflt" :chartName="$t('risk.preeclampsia')" markerName="sFlt-1" unit="ng/mL" :allMarkerType="6" :itemType="0" height="280px" />
          </a-col>
          <a-col :span="24" v-if="settingInfo.showMap">
            <mark-point idName="preMap" :chartName="$t('risk.preeclampsia')" markerName="MAP" unit="mmHg" :allMarkerType="0" :itemType="0" height="280px" />
          </a-col>
          <a-col :span="24" v-if="settingInfo.showUtpi">
            <mark-point idName="preUtpi" :chartName="$t('risk.preeclampsia')" markerName="UTPI" unit="ua" :allMarkerType="2" :itemType="0" height="280px" />
          </a-col>
          <a-col :span="24" v-if="settingInfo.showPappa">
            <mark-point idName="downsPappa" :chartName="$t('risk.downs')" markerName="PAPP-A" unit="uIU/mL" :allMarkerType="5" :itemType="1" height="280px" />
          </a-col>
          <a-col :span="24" v-if="settingInfo.showHcgb">
            <mark-point idName="downsHcgb" :chartName="$t('risk.downs')" markerName="Free β-hCG" unit="ng/mL" :allMarkerType="7" :itemType="1" height="280px" />
          </a-col>
          <a-col :span="24" v-if="settingInfo.showAfp">
            <mark-point idName="downsAfp" :chartName="$t('risk.downs')" markerName="AFP" unit="ng/mL" :allMarkerType="8" :itemType="1" height="280px" />
          </a-col>
          <a-col :span="24" v-if="settingInfo.showUe3">
            <mark-point idName="downsUE3" :chartName="$t('risk.downs')" markerName="UE3" unit="ng/mL" :allMarkerType="9" :itemType="1" height="280px" />
          </a-col>
          <a-col :span="24" v-if="settingInfo.showInhiba">
            <mark-point idName="downsINHIBA" :chartName="$t('risk.downs')" markerName="Inhibin-A" unit="ng/mL" :allMarkerType="10" :itemType="1" height="280px" />
          </a-col>
          <a-col :span="24" v-if="settingInfo.showNt">
            <mark-point idName="downsNT" :chartName="$t('risk.downs')" markerName="NT" unit="mm" :allMarkerType="3" :itemType="1" height="280px" />
          </a-col>
          <a-col :span="24" v-if="settingInfo.showPlgf">
            <mark-point idName="sgaPlgf" :chartName="$t('risk.sga')" markerName="PLGF" unit="pg/mL" :allMarkerType="4" :itemType="2" height="280px" />
          </a-col>
          <a-col :span="24" v-if="settingInfo.showPappa">
            <mark-point idName="sgaPappa" :chartName="$t('risk.sga')" markerName="PAPP-A" unit="uIU/mL" :allMarkerType="5" :itemType="2" height="280px" />
          </a-col>
          <a-col :span="24" v-if="settingInfo.showEfw">
            <mark-point idName="sgaEfw" :chartName="$t('risk.sga')" markerName="EFW" unit="g" :allMarkerType="1" :itemType="2" height="280px" />
          </a-col>
          <a-col :span="24" v-if="settingInfo.showPlgf">
            <mark-point idName="fgrPlgf2" :chartName="$t('risk.fgr')" markerName="PLGF" unit="pg/mL" :allMarkerType="4" :itemType="3" height="280px" />
          </a-col>
          <a-col :span="24" v-if="settingInfo.showPappa">
            <mark-point idName="fgrPappa2" :chartName="$t('risk.fgr')" markerName="PAPP-A" unit="uIU/mL" :allMarkerType="5" :itemType="3" height="280px" />
          </a-col>
        </a-row>
      </div>
    </a-spin>
  </div>
</template>

<script>
import PositiveDetectionRate from './components/PositiveDetectionRate.vue'
import GestationalWeekDistribution from './components/GestationalWeekDistribution.vue'
import PregnantWomenAgeDistribution from './components/PregnantWomenAgeDistribution.vue'
import EclampsiaRiskRate from './components/EclampsiaRiskRate.vue'
import SgaRiskRate from './components/SgaRiskRate.vue'
import DownsRiskRate from './components/DownsRiskRate.vue'
import FgrRiskRate from './components/FgrRiskRate.vue'
import DvtRiskRate from './components/DvtRiskRate.vue'
import MarkPoint from './components/MarkPoint.vue'
import Panel from './components/Panel.vue'
import PanelLarge from './components/PanelLarge.vue'
export default {
  name: 'Home',
  components: {
    PositiveDetectionRate,
    GestationalWeekDistribution,
    PregnantWomenAgeDistribution,
    EclampsiaRiskRate,
    SgaRiskRate,
    DownsRiskRate,
    FgrRiskRate,
    DvtRiskRate,
    Panel,
    PanelLarge,
    MarkPoint
  },
  data () {
    return {
      loading: false,
      settingInfo: {},
      positiveData: {
        titleList: ['子痫前期', '唐氏综合症', '小于胎龄儿', '胎儿生长受限'],
        dataList: ['20', '12'],
        dataList2: ['15', '14']
      },
      weekData: {
        dateList: ['<34周', '34-37周', '37-42周', '≥42周'],
        dataList: ['30', '12', '75', '40']
      },
      ageData: {
        dateList: ['<26岁', '26-30岁', '30-35岁', '>35岁'],
        dataList: ['30', '65', '25', '40']
      },
      eclData: {
        dataList: [
          {name: '家族子痫前期史', value: 111},
          {name: '慢性高血压', value: 420},
          {name: '怀孕方式', value: 113},
          {name: '肥胖', value: 138},
          {name: '糖尿病', value: 148}
        ]
      },
      plgfData: {
        dateList: ['7', '14', '21', '28'],
        dataList: ['30', '65', '25', '40'],
        pointList: [
          ['42', '7'],
          ['58', '8'],
          ['30', '2'],
          ['21', '4'],
          ['10', '9'],
          ['30', '8'],
          ['14', '13'],
          ['11', '26'],
          ['30', '21']
        ],
        TH5: '13',
        TH95: '30'

      }
    }
  },
  computed: {},
  mounted () {
    this.getSetting()
  },
  methods: {
    getSetting () {
      this.loading = true
      this.$get('web/normal-setting/getSetting', {}).then((r) => {
        let data = r.data
        if (data.code === 200) {
          if (data.data) {
            this.settingInfo = data.data
          }
          setTimeout(() => {
            this.loading = false
          }, 500)
          this.$forceUpdate()
        } else {
          this.$message.error(data.message)
          setTimeout(() => {
            this.loading = false
          }, 500)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
}

.header {
  width: 100%;
  background-color: #fff;
}
.m_top {
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/manage/home/Home.vue